import React, { useEffect, useState } from "react";

import { ChevronDown, ChevronUp } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { bindActionCreators } from "redux";

import Step from "./Step";
import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading";
import Widgets from "../../Widgets/Widgets";
import StudentDo from "../Do/StudentDo";

import "./style.css";

function StudentView({
  trail,
  allocation_id: allocationId,
  currentStep,
  handleStep,
  totalSteps,
  maxStepAvailable,
  userToken,
  userId,
  userName
}) {
  const [currentActivatedStep, setCurrentActivatedStep] = useState(null);
  const [currentTrail, setCurrentTrail] = useState(trail);
  const [
    paginationDirectionAvailableStep,
    setPaginationDirectionAvailableStep
  ] = useState({
    up: false,
    down: false
  });
  const [showEvaluation, setShowEvaluation] = useState(false);
  const [respTrailAllocationSingleView, setRespTrailAllocationSingleView] =
    useState(null);

  const [flagUpdateInfo, setFlagUpdateInfo] = useState(false);
  const [loadingNavigationStep, setLoadingNavigationStep] = useState(false);
  const [source, setSource] = useState(null);
  const [isLoadingSingleViewByExecution, setIsLoadingSingleViewByExecution] =
    useState(false);

  const currentPath = useLocation();

  const checkIfShowEvaluation = () => {
    let check = true;
    for (let i = 0; i < trail.trail_activities.length - 1; i++) {
      if (trail.trail_activities[i].activity.executions.length === 0) {
        check = false;
        break;
      } else {
        if (
          trail.trail_activities[i].activity.executions[0]
            .completion_percentage !== 100
        ) {
          check = false;
          break;
        }
      }
    }
    setShowEvaluation(check);
  };

  const clearLocalStorage = () => {
    const size = trail.trail_activities.length;
    const lastActivityId = trail.trail_activities[size - 1].activity.id;
    localStorage.removeItem(`${lastActivityId}`);
  };

  useEffect(() => {
    checkAvailablePagination();
  }, [currentStep]);

  useEffect(() => {
    initializeActivity();
  }, []);

  useEffect(() => {
    function checkUserData() {
      // setCurrentTrail(trail);
      const size = trail.trail_activities.length;
      const lastActivityId = trail.trail_activities[size - 1].activity.id;
      const item = localStorage.getItem(`${lastActivityId}`);

      if (item) {
        let obj = JSON.parse(item);
        wasOpened(obj.executionId, obj.activityId, trail);
      }
    }

    window.addEventListener("storage", checkUserData);

    return () => {
      window.removeEventListener("storage", checkUserData);
      clearLocalStorage();
    };
  }, [trail]);

  const handleCurrencActivatedStep = (activity, position) => {
    let copyTrail = { ...currentTrail };
    copyTrail.trail_activities.map(item => {
      item.activated = false;
    });
    copyTrail.trail_activities[position].activated = true;
    setCurrentTrail(copyTrail);
    setCurrentActivatedStep(activity);
  };

  const getDescription = description => {
    try {
      const parsedDescription = JSON.parse(description);
      const result = parsedDescription
        .map(node => node.children.map(child => child.text).join(" \n"))
        .join("\n");
      if (result === "null") {
        return "";
      }
      return result.trim();
    } catch {
      return "";
    }
  };

  const paginationStep = direction => {
    setLoadingNavigationStep(true);
    if (direction === "up" && currentStep > 0) {
      handleStep(currentStep - 1, direction);
    } else if (direction === "down" && currentStep < totalSteps) {
      handleStep(currentStep + 1, direction);
    }
  };

  const checkAvailablePagination = completedEvaluation => {
    if (completedEvaluation) {
      if (currentStep < totalSteps) {
        let copyPaginationDirectionAvailableStep = {
          ...paginationDirectionAvailableStep
        };
        copyPaginationDirectionAvailableStep.down = true;

        setPaginationDirectionAvailableStep(
          copyPaginationDirectionAvailableStep
        );
      }
    } else {
      let obj = {
        up: false,
        down: false
      };
      if (currentStep > 1) {
        obj.up = true;
      }
      if (currentStep < maxStepAvailable) {
        obj.down = true;
      }
      setPaginationDirectionAvailableStep(obj);
    }
  };

  const handleIsLoadingSingleViewByExecution = bool => {
    setIsLoadingSingleViewByExecution(bool);
  };

  const wasOpened = (executionId, activityId, curTrail) => {
    axios
      .get(`${URL.api}activity/activity/singleViewByExecution/${executionId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      })
      .then(resp => {
        setCurrentTrail(null);

        if (resp.data.data) {
          let newCurrentTrail;
          if (curTrail) {
            newCurrentTrail = { ...curTrail };
          } else {
            newCurrentTrail = { ...currentTrail };
          }

          if (newCurrentTrail?.trail_activities) {
            const index = newCurrentTrail?.trail_activities.findIndex(
              activity => Number(activity.activity_id) === Number(activityId)
            );

            if (
              newCurrentTrail?.trail_activities[index]?.activity?.executions
                .length > 0
            ) {
              newCurrentTrail.trail_activities[index].last_application =
                resp.data.data.last_application;

              newCurrentTrail.trail_activities[
                index
              ].activity.executions[0].completion_percentage =
                resp.data.data.activity_percentage;

              if (
                resp.data.data.last_application &&
                resp.data.data.items[0].type_id === 12
              ) {
                let itemsArr = [
                  { final_grade: resp.data.data.last_application.final_grade }
                ];
                newCurrentTrail.trail_activities[
                  index
                ].activity.executions[0].items = itemsArr;
              }
            } else {
              let obj = {
                completion_percentage: resp.data.data.activity_percentage
              };
              // Caso de avaliação:
              if (
                resp.data.data.items.length &&
                resp.data.data.items[0].type_id === 12
              ) {
                obj.items = [
                  { final_grade: resp.data.data.items[0].item_grade }
                ];
              }
              newCurrentTrail?.trail_activities[
                index
              ]?.activity.executions?.push(obj);
            }
          }

          const lastActivityIndex = newCurrentTrail.trail_activities.length - 1;

          // Mostra paginação se a completion percentage do último(avaliação) item for 100
          if (
            newCurrentTrail.trail_activities[
              newCurrentTrail.trail_activities.length - 1
            ]?.activity.executions[0]?.completion_percentage === 100 ||
            newCurrentTrail.trail_activities[lastActivityIndex]?.activity
              .items[0].applications.length > 0
          ) {
            checkAvailablePagination(true);
          } else {
            checkAvailablePagination();
          }

          setCurrentTrail(newCurrentTrail);
          if (!curTrail) {
            checkIfShowEvaluation();
          }
        }
      });
  };

  useEffect(() => {
    setFlagUpdateInfo(!flagUpdateInfo);
  }, [currentTrail]);

  useEffect(() => {
    if (trail.trail_activities.length) {
      trail.trail_activities[0].activated = true;
      setCurrentActivatedStep(trail.trail_activities[0]);
    }
    checkIfShowEvaluation();
    setCurrentTrail(trail);
    checkAvailablePagination();
  }, [trail]);

  const initializeActivity = () => {
    const searchParams = currentPath.search
      .substring(1)
      .split("&")
      .reduce(
        (acc, cur) => ({
          ...acc,
          [cur.split("=")[0]]: cur.split("=")[1]
        }),
        {}
      );

    const requestURL =
      searchParams?.partialprogression === "true"
        ? `${URL.api}activity/trail_allocation/partial_progression/singleView/${allocationId}`
        : `${URL.api}activity/trail_allocation/singleView/${allocationId}`;

    if ("partialprogression" in searchParams) setSource("partialprogression");

    axios
      .get(requestURL, {
        headers: { authorization: `Bearer ${userToken}` }
      })
      .then(resp => {
        if (resp.data.success) {
          setRespTrailAllocationSingleView(resp.data);
        }
      })
      .catch(error => {
        toastr.error("Error fetching trail allocation:", error.response.data);
      });
  };

  const hasAbleNextStep =
    paginationDirectionAvailableStep.down && !loadingNavigationStep;

  const hasAblePreviousStep =
    paginationDirectionAvailableStep.up && !loadingNavigationStep;

  return (
    <>
      <div className="screen">
        <div className="layout">
          <div className="edge">
            <div
              className={`d-flex justify-content-center align-items-center steps-navigation-link steps-navigation-link ${
                !hasAblePreviousStep && "steps-navigation-link-disabled"
              }`}
              onClick={() => {
                if (hasAblePreviousStep) paginationStep("up");
              }}
            >
              <ChevronUp size={16} />
              <h3
                className={`steps-navigation-label mb-0 ml-2 ${
                  hasAblePreviousStep && "steps-navigation-label-active"
                }`}
              >
                Passo Anterior
              </h3>
            </div>
            <div className="step-list-container">
              {!currentTrail ? (
                <Loading />
              ) : (
                <div className="edge-line">
                  <div className="steps">
                    {currentTrail.trail_activities.map((activity, index) => (
                      <Step
                        disable={isLoadingSingleViewByExecution}
                        key={index}
                        position={index}
                        activity={activity}
                        isFirstStep={index === 0}
                        handleCurrencActivatedStep={handleCurrencActivatedStep}
                        showEvaluation={showEvaluation}
                        isLastStep={
                          index === currentTrail.trail_activities.length - 1
                        }
                        userId={userId}
                        flagUpdateInfo={flagUpdateInfo}
                        loadingNavigationStep={loadingNavigationStep}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div
              className={`d-flex justify-content-center align-items-center steps-navigation-link steps-navigation-link text-right ${
                !hasAbleNextStep && "steps-navigation-link-disabled"
              }`}
              onClick={() => {
                if (hasAbleNextStep) paginationStep("down");
              }}
            >
              <h3
                className={`steps-navigation-label mb-0 mr-2 ${
                  hasAbleNextStep && "steps-navigation-label-active"
                }`}
              >
                Próximo Passo
              </h3>
              <ChevronDown size={16} />
            </div>
          </div>
          <div className="content">
            <div className="step-card-content-header">
              <span
                style={{
                  color: "#00263B",
                  marginBottom: "-6px"
                }}
                title={`${currentActivatedStep?.activity.name}`}
              >
                {currentActivatedStep?.activity.name}
              </span>
            </div>
            <div className="step-card-content-cards">
              <div className="step-card-container-cards">
                {currentActivatedStep && respTrailAllocationSingleView && (
                  <>
                    <span>
                      {getDescription(
                        currentActivatedStep?.activity.description
                      )}
                    </span>
                    <div className="content-items">
                      <StudentDo
                        handleIsLoadingSingleViewByExecution={
                          handleIsLoadingSingleViewByExecution
                        }
                        lastApplication={currentActivatedStep.last_application}
                        source={source}
                        wasOpened={wasOpened}
                        respTrailAllocationSingleView={
                          respTrailAllocationSingleView
                        }
                        match={{
                          params: {
                            allocation_id: allocationId,
                            id: currentActivatedStep.activity_id
                          }
                        }}
                        setLoadingNavigationStep={setLoadingNavigationStep}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentView);
